import PropTypes from 'prop-types';

const auditLogPropTypes = {
  recordRef: PropTypes.shape({
    entity: PropTypes.string.isRequired,
    scopeValues: PropTypes.object.isRequired,
    displayName: PropTypes.string,
  }),
  globalFilters: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    description: PropTypes.string,
    actions: PropTypes.array,
    dateRange: PropTypes.shape({ startDate: PropTypes.object, endDate: PropTypes.object }),
  }),
};

export default auditLogPropTypes;
